export enum ClipboardTypeEnum {
  DEFAULT = 'mp-clipboard-text',
  TEXT = 'mp-clipboard-text',
  TEXT_HOVER = 'mp-clipboard-text_hover',
  ICON = 'mp-clipboard-icon',
  BUTTON = 'mp-clipboard-button'
}
